<template>
  <v-card>
    <v-card-title></v-card-title>
    <v-card-text class="body-2 black--text">
      <v-row dense>
        <v-col cols="12">
          <div class="align-center d-flex flex-row justify-space-between w-full">
            <div class="font-weight-bold text-h5">Updates</div>
            <div class="light-gray">July 2022</div>
          </div>
        </v-col>
        <v-col cols="12" class="mt-1">
          <p class="body-1 font-weight-medium">Coming Soon!</p>
        </v-col>
      </v-row>
      <div
          v-for="(update, i) in updates"
          :key="i"
          class="d-flex mb-4"
      >
        <div class="bullet-wrapper">
          <svg viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg" class="bullet">
            <circle cx="50%" cy="50%" r="50%"/>
          </svg>
        </div>
        <div>
          <div
              :class="{[`label-${update.type}`]: true}"
              class="label ml-n2 mr-2"
          >
            {{ update.type[0].toUpperCase() + update.type.slice(1) }}
          </div>
          <span>{{ update.title }}</span>
          <div
              v-if="update.subtitle"
              class="my-1 light-gray"
          >{{ update.subtitle }}</div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
          block
          class="mb-2"
          color="#1A82FF"
          dark
          large
          @click="$emit('close')"
      >
        Continue
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "AppWhatsNew",
  data() {
    return {
      // type can be new, updated, or fixed
      updates: [
        {
          type: 'new',
          title: 'Optional Mobile View',
          subtitle: 'Bringing back the mobile view option for those who work on the go'
        }, {
          type: 'updated',
          title: 'Added Ability to Choose Calendar Time Increments',
          subtitle: 'Choose between 15, 30, or 60 minute time slots on the day view of the calendar'
        }, {
          type: 'updated',
          title: 'Added Follow Up Notes to Inspection Sheet',
          subtitle: 'You all asked to have follow up notes added to the inspection sheet when applicable, check them out!'
        }, {
          type: 'updated',
          title: 'Added Map Links to Inspection Sheet',
          subtitle: 'Now you can click or tap on addresses to view on the map!'
        }
      ]
    }
  },
}
</script>

<style scoped>
.label {
  display: inline-block;
  border-radius: 5px;
  padding: 0 8px;
  font-weight: 500;
}
.label-new {
  color: #25C12B;
  background-color: rgba(37, 193, 43, 0.1);
}
.label-updated {
  color: #1A82FF;
  background-color: rgba(26, 130, 255, 0.1);
}
.label-fixed {
  color: #FF2F2F;
  background-color: rgba(255, 47, 47, 0.1);
}
.whats-new {
  font-size: 1.143rem !important;
}
.bullet {
  fill: #DFDFDF;
  width: 8px;
  height: 8px;
  margin-bottom: 1px;
}
.bullet-wrapper {
  width: 32px;
  min-width: 28px;
}
.w-full {
  width: 100%;
}
.light-gray {
  color: rgba(0, 0, 0, 0.3);
}
</style>